
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/barcode-generator",
      function () {
        return require("private-next-pages/barcode-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/barcode-generator"])
      });
    }
  